import Endpoints from 'constants/Endpoints';
import {RestRequestDELETE, RestRequestGET, RestRequestPOST, RestRequestPUT} from 'libs/RestRequest';
import applySearchParams from "../libs/applySearchParams";
import applySortParams from "../libs/applySortParams";
import reduxStore from "redux/store";
import {setSaveStatusClosed, setSaveStatusError, setSaveStatusLoading} from "../redux/actions";
import isResponseValid from "../libs/isResponseValid";
import Tr   from "translations/Translations";

const __get = async (url) => {
    try {
        let res = await RestRequestGET(url)
        return res;
    } catch (error) {
    }
}

const __save = async (url, values) => {
    reduxStore.dispatch(setSaveStatusLoading());
    try {
        const resp = await RestRequestPOST(url, values)
        isResponseValid(resp, (e) => {
            throw new Error(e);
        })
        reduxStore.dispatch(setSaveStatusClosed());
        return resp;
    } catch (e) {
        console.error(e)
        reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')))
    }
}


const getTemplatesList = async (searchData) => {
    const {pagination, search, sort} = searchData;

    let params = {
        ...pagination
    }
    params = applySearchParams(search, params);
    params = applySortParams(sort, params);
    return await RestRequestGET(Endpoints.PURCHASING_GROUP_TEMPLATES_LIST(), {params});
}

const getTemplateListHasEdit = async () => {
    return __get(Endpoints.PURCHASING_GROUP_TEMPLATES_LIST_HAS_EDIT())
}
const getTemplate = async (templateId) => {
    return __get(Endpoints.PURCHASING_GROUP_TEMPLATES_TEMPLATE_ID(templateId))
}

const saveTemplate = async (templateId, values) => {
    return __save(Endpoints.PURCHASING_GROUP_TEMPLATES_TEMPLATE_ID(templateId), values)
}

const cloneTemplate = async (templateId) => {
    return RestRequestPOST(Endpoints.PURCHASING_GROUP_TEMPLATES_TEMPLATE_ID_CLONE(templateId))
}

const deleteTemplate = async (templateId) => {
    return RestRequestDELETE(Endpoints.PURCHASING_GROUP_TEMPLATES_TEMPLATE_ID(templateId))
}
const activateTemplate = async (templateId) => {
    return RestRequestPUT(Endpoints.PURCHASING_GROUP_TEMPLATES_TEMPLATE_ID_ACTIVATE(templateId));
}
const deactivateTemplate = async (templateId) => {
    return RestRequestPUT(Endpoints.PURCHASING_GROUP_TEMPLATES_TEMPLATE_ID_DEACTIVATE(templateId));
}


export default {
    getTemplatesList,
    getTemplateListHasEdit,
    getTemplate,
    saveTemplate,
    cloneTemplate,
    deleteTemplate,
    activateTemplate,
    deactivateTemplate
}